import { Elm } from './Main.elm'

export default Elm